/**
 * Put all the options for this library that must be set in the `main.ts` of the application here.
 */
export interface PreconUserProfilesGlobalOptions {
    /**
     * The fallback letters for an user-avatar.
     *
     * @default '??'
     */
    defaultAvatarFallbackLetters?: string;
    /**
     * The placeholder for when no name of a user was found.
     *
     * @default '-- naam onbekend --'
     */
    noUserNamePlaceholder?: string;
    /**
     * The expected amount of teams that one use may have.
     *
     * Used to show the loaded in the `CurrentTeamSelector` component.
     *
     * @default 3
     */
    expectedTeamCount?: number;
    /**
     * The title to use for myTeams sections.
     *
     * @default 'Mijn Teams'
     */
    myTeamsTitle?: string;
}

/**
 * This is the type of the options object used within the library.
 */
export type NormalizedPreconUserProfilesGlobalOptions =
    Required<PreconUserProfilesGlobalOptions>;

/**
 * Function to convert the input options (`FreyaUserProfilesGlobalOptions`) to the normalized
 * options (`NormalizedFreyaUserProfilesGlobalOptions`).
 *
 * It usually just sets the default values for the library.
 *
 * @param options The input options as set in the application that uses this library.
 */
export function normalizePreconUserProfilesOptions(
    options?: PreconUserProfilesGlobalOptions
): NormalizedPreconUserProfilesGlobalOptions {
    return {
        defaultAvatarFallbackLetters:
            options?.defaultAvatarFallbackLetters ?? '??',
        noUserNamePlaceholder:
            options?.noUserNamePlaceholder ?? '-- naam onbekend --',
        expectedTeamCount: options?.expectedTeamCount ?? 3,
        myTeamsTitle: options?.myTeamsTitle ?? 'Mijn Teams',
    };
}
